import { useNavigate } from "react-router-dom";

function PrivacyPolicy() {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: "100vh", background: "#03070d", color: "white", padding: "70px 20px 40px" }}>
      <button onClick={() => navigate(
  new URLSearchParams(window.location.search).get("retour") === "assistance"
    ? "/assistance"
    : "/"
)} style={backBtn}>← Retour</button>

      <div style={card}>
        <h1 style={title}>Politique de confidentialité</h1>

        <p>
          EVO-LIVE respecte la vie privée de ses utilisateurs et s’engage à protéger les données personnelles
          collectées dans le cadre de l’utilisation de son application, de son site vitrine et de ses services.
        </p>

        <h2 style={sub}>1. Responsable du traitement</h2>
        <p>
          Le responsable du traitement des données est EVO-LIVE SAS.
        </p>
        <p>
          Contact : <span style={link}>evo.contact@gmail.com</span>
        </p>

        <h2 style={sub}>2. Données collectées</h2>
        <p>
          EVO-LIVE peut collecter les données suivantes :
        </p>
        <ul>
          <li>email, pseudo, mot de passe chiffré ;</li>
          <li>photo de profil, biographie, vidéos, stories, lives et contenus publiés ;</li>
          <li>messages privés, commentaires, signalements et interactions ;</li>
          <li>achats de coins, cadeaux virtuels, transactions et historiques liés au compte ;</li>
          <li>demandes de certification, documents transmis volontairement et informations associées ;</li>
          <li>données techniques : adresse IP, appareil, système, logs, sécurité et erreurs ;</li>
          <li>données nécessaires au fonctionnement des notifications, de la modération et de la sécurité.</li>
        </ul>

        <h2 style={sub}>3. Utilisation des données</h2>
        <p>
          Les données sont utilisées pour :
        </p>
        <ul>
          <li>créer et gérer les comptes utilisateurs ;</li>
          <li>permettre la publication de vidéos, stories, lives, messages et commentaires ;</li>
          <li>gérer les achats de coins, cadeaux virtuels et transactions ;</li>
          <li>assurer la sécurité, la modération, la lutte contre la fraude, les abus et le spam ;</li>
          <li>traiter les signalements, sanctions, restrictions ou suppressions de contenus ;</li>
          <li>améliorer le service et corriger les erreurs techniques ;</li>
          <li>respecter les obligations légales, fiscales, comptables et réglementaires.</li>
        </ul>

        <h2 style={sub}>4. Droit à l’image et contenus publiés</h2>
        <p>
          En publiant une vidéo, une photo, une story, un live ou tout autre contenu sur EVO-LIVE,
          l’utilisateur reconnaît disposer des droits nécessaires et autorise leur diffusion sur la plateforme.
        </p>
        <p>
          L’utilisateur s’engage à ne pas publier l’image, la voix ou les données d’une autre personne sans son accord.
          EVO-LIVE peut retirer tout contenu signalé, illicite, abusif ou contraire aux règles de la plateforme.
        </p>

        <h2 style={sub}>5. Messages privés et communications</h2>
        <p>
          Les messages privés sont utilisés pour permettre la communication entre utilisateurs.
          Ils peuvent être analysés de manière limitée en cas de signalement, de suspicion d’abus, de fraude,
          de harcèlement ou d’obligation légale.
        </p>

        <h2 style={sub}>6. Lives et diffusions en direct</h2>
        <p>
          Les lives peuvent être visibles par d’autres utilisateurs en temps réel. Les utilisateurs sont responsables
          de ce qu’ils diffusent. EVO-LIVE peut interrompre, restreindre ou supprimer un live en cas de violation
          des règles, de signalement ou de risque pour la sécurité.
        </p>

        <h2 style={sub}>7. Coins, cadeaux virtuels et paiements</h2>
        <p>
          Les coins et cadeaux virtuels sont des éléments numériques utilisables uniquement dans l’application.
          Les informations liées aux achats, transactions et cadeaux peuvent être conservées pour assurer le suivi,
          la sécurité, la preuve de paiement et le respect des obligations légales.
        </p>
        <p>
          Les paiements peuvent être traités par des prestataires externes tels que Google Play, Apple App Store
          ou tout autre prestataire de paiement autorisé.
        </p>

        <h2 style={sub}>8. Remboursements et erreurs de paiement</h2>
        <p>
          En cas d’erreur technique, de double paiement ou de problème lié à une transaction, l’utilisateur peut
          contacter EVO-LIVE. Les demandes sont étudiées au cas par cas selon les règles applicables, les conditions
          des plateformes de paiement et la réglementation en vigueur.
        </p>

        <h2 style={sub}>9. Partage des données</h2>
        <p>
          EVO-LIVE ne vend pas les données personnelles des utilisateurs.
          Certaines données peuvent être transmises à des prestataires techniques strictement nécessaires au service :
          hébergement, sécurité, paiement, analyse technique, notifications ou obligations légales.
        </p>

        <h2 style={sub}>10. Hébergement et sécurité</h2>
        <p>
          Les données sont hébergées sur des serveurs sécurisés. EVO-LIVE met en œuvre des mesures techniques
          raisonnables pour protéger les comptes, les contenus, les transactions et les données personnelles.
        </p>
        <p>
          Malgré ces mesures, aucun système informatique ne peut garantir une sécurité absolue.
          L’utilisateur doit protéger ses identifiants et signaler toute utilisation suspecte de son compte.
        </p>

        <h2 style={sub}>11. Conservation des données</h2>
        <p>
          Les données sont conservées pendant la durée nécessaire au fonctionnement du service, à la sécurité,
          à la modération, aux obligations légales, fiscales, comptables ou à la résolution des litiges.
        </p>
        <p>
          Certains contenus supprimés peuvent être conservés temporairement pour des raisons de sécurité,
          de preuve, de modération ou d’obligation légale.
        </p>

        <h2 style={sub}>12. Suppression du compte</h2>
        <p>
          L’utilisateur peut demander la suppression de son compte. Certaines données peuvent toutefois être conservées
          si elles sont nécessaires au respect d’une obligation légale, à la prévention de la fraude, à la sécurité
          ou à la gestion d’un litige.
        </p>

        <h2 style={sub}>13. Droits des utilisateurs</h2>
        <p>
          Conformément à la réglementation applicable, l’utilisateur peut demander l’accès, la rectification,
          l’effacement, la limitation ou l’opposition au traitement de ses données personnelles.
        </p>
        <p>
          Pour exercer ces droits, l’utilisateur peut contacter EVO-LIVE à l’adresse suivante :
          <br />
          <span style={link}>evo.contact@gmail.com</span>
        </p>

        <h2 style={sub}>14. Mineurs</h2>
        <p>
          L’utilisation de la plateforme est réservée aux personnes autorisées selon les lois applicables
          et les règles des boutiques d’applications. Les mineurs doivent obtenir l’autorisation de leur représentant légal
          lorsque cela est requis.
        </p>

        <h2 style={sub}>15. Cookies et technologies similaires</h2>
        <p>
          Le site vitrine ou certains services peuvent utiliser des cookies ou technologies similaires pour assurer
          le fonctionnement du service, mesurer l’audience, améliorer l’expérience utilisateur ou sécuriser la plateforme.
        </p>

        <h2 style={sub}>16. Modification de la politique</h2>
        <p>
          EVO-LIVE peut modifier la présente politique de confidentialité afin de l’adapter aux évolutions du service,
          de la loi ou des obligations techniques. La version applicable est celle disponible sur la plateforme.
        </p>

        <h2 style={sub}>17. Contact</h2>
        <p>
          Pour toute question relative à la confidentialité, aux données personnelles, aux remboursements,
          aux contenus publiés ou à la suppression d’un compte :
        </p>
        <p style={link}>evo.contact@gmail.com</p>

        <p style={footer}>EVO-LIVE SAS – Tous droits réservés</p>
      </div>
    </div>
  );
}

const backBtn = {
  position: "fixed",
  top: 20,
  left: 20,
  zIndex: 9999,
  border: "1px solid rgba(0,242,255,0.55)",
  background: "rgba(0, 12, 20, 0.9)",
  color: "#00f2ff",
  padding: "10px 16px",
  borderRadius: 999,
  fontWeight: "bold",
  cursor: "pointer",
  boxShadow: "0 0 18px rgba(0,242,255,0.35)",
};

const card = {
  maxWidth: 900,
  margin: "auto",
  padding: "32px 24px",
  borderRadius: 26,
  background: "rgba(0, 12, 20, 0.82)",
  border: "1px solid rgba(0,242,255,0.28)",
  boxShadow: "0 0 35px rgba(0,242,255,0.14)",
  lineHeight: 1.7,
};

const title = {
  color: "#00f2ff",
  marginBottom: 25,
  textShadow: "0 0 18px rgba(0,242,255,0.6)",
};

const sub = {
  color: "#00f2ff",
  marginTop: 28,
};

const link = {
  color: "#00f2ff",
  fontWeight: "bold",
};

const footer = {
  marginTop: 40,
  fontSize: 12,
  opacity: 0.7,
};

export default PrivacyPolicy;